import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import './form.css'

export const FormContainer = props => {
    const {
        initialValues,
        validationSchema,
        onSubmit,
        children: Component,
        enableReinitialize,
        ...rest
    } = props
    const validation = Yup.object(validationSchema)
    const submitHandler = (values, actions) => onSubmit(values, actions)

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validation}
            onSubmit={submitHandler}
            enableReinitialize={Boolean(enableReinitialize)}
            {...rest}
        >
            {formik => (
                <Form>
                    <Component {...formik} />
                </Form>
            )}
        </Formik>
    )
}
